<template>
  <div class="flex justify-end items-center py-4">
    <font-awesome-icon :icon="['fas', 'bell']" class="text-xl mr-8" />
    <!-- <router-link to="/business/campaigns/create"><font-awesome-icon :icon="['fas', 'upload']" class="text-3xl mr-10" /></router-link> -->
    <div class="w-[40px] h-[40px] bg-indigo-100 rounded-full flex items-center justify-center mr-2">
      <font-awesome-icon :icon="['fas', 'suitcase']" />
    </div>
    Company
  </div>
</template>
<script>
export default {
}
</script>